/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmissionReport } from './submissionReport';

export type GenericApiResponseSubmissionReportData = SubmissionReport | null;
